import api from "PFCore/api";
import { AvailabilityRuleV2 } from "PFTypes";

export const validateAvailabilityRequirements = (availability: Partial<AvailabilityRuleV2>): Promise<void> =>
  api({
    url: "validations/availability_requirements",
    method: "POST",
    data: {
      availability
    }
  });
